/**
 * AIVA-6639 — telemetry for the AI disclaimer.
 *
 * Follows the storage-failure convention already used by `userSkillPrefs.ts`
 * and `chatHistoryStorage.ts`: a pseudo-connector name plus a closed-enum
 * `reason`, so failures land in the existing connector-reliability pivot
 * without widening the telemetry event catalogue. The success event doubles as
 * a server-side trace of who acknowledged — the backend stamps the user from
 * the bearer token — which the browser-only record cannot provide.
 */
import { logConnectorFailure, logConnectorSuccess } from "../telemetry";

export const AI_NOTICE_TELEMETRY_SOURCE = "ai-notice";

export const AI_NOTICE_REASON = {
  acknowledged: "ack_recorded",
  readFailed: "ack_read_error",
  recordInvalid: "ack_record_invalid",
  writeFailed: "ack_write_error",
  storageUnavailable: "ack_storage_unavailable",
  cleanupFailed: "ack_cleanup_error",
  partitionKeyFailed: "ack_partition_key_error",
} as const;

export type AiNoticeFailureReason = Exclude<
  (typeof AI_NOTICE_REASON)[keyof typeof AI_NOTICE_REASON],
  typeof AI_NOTICE_REASON.acknowledged
>;

export function reportAiNoticeFailure(reason: AiNoticeFailureReason, err: unknown): void {
  logConnectorFailure(AI_NOTICE_TELEMETRY_SOURCE, err, reason);
}

export function reportAiNoticeAcknowledged(): void {
  logConnectorSuccess(AI_NOTICE_TELEMETRY_SOURCE, AI_NOTICE_REASON.acknowledged);
}
